import { Component, EventEmitter, Output } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'lib-import-xlsx',
  standalone: true,
  imports: [],
  templateUrl: './import-xlsx.component.html',
  styleUrl: './import-xlsx.component.css'
})
export class ImportXlsxComponent {

  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  data: any;

  onFileChange(evt: any): void {
    const target: DataTransfer = <DataTransfer>(evt.target);

    if (target.files.length !== 1) {
      console.error('Cannot use multiple files');
      return;
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.data = XLSX.utils.sheet_to_json(ws, { header: 1 });      
      this.valueChange.emit(this.data);
    };
    reader.readAsBinaryString(target.files[0]);
  }

}
